<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist
                @help="help"
                @add="add"
                @reflash="reflash"
                @del="batchDel"
                @exps="exp"
                ref="SetBtn"
        ></buttonlist>
        <!-- 功能按钮 -->
        <!-- 表格 -->
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                @cell-dblclick="editInfo"
                tab-click="selectInfo(0)"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="exclusively_id" label="ID" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="tablename" :label="$t('getapi[8190]')" width="200"></el-table-column>
            <el-table-column show-overflow-tooltip prop="chtablename" :label="$t('getapi[8191]')" width="120"></el-table-column>
            <el-table-column prop="ordertype" :label="$t('getapi[2285]')" width="100">
                <template slot-scope="scope">
                    <span>{{scope.row.ordertype == 'ordinary'?$t('getapi[4349]'):$t('getapi[2096]')}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="cargoname" :label="$t('getapi[2493]')" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="chcargoname" :label="$t('getapi[2494]')" width="150"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')" width="100"></el-table-column>
            <el-table-column :label="$t('getapi[6048]')" width="60">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope.row)" type="text"
                               size="small">{{ $t('getapi[34]') }}
                    </el-button>
                    <!-- <el-popconfirm
                            :confirmButtonText="$t('getapi[937]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]')
                            }}
                        </el-button>
                    </el-popconfirm> -->
                </template>
            </el-table-column>
        </el-table>
        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[34]')" width="30%" :close-on-click-modal="false">
            <el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[8190]')}}</td>
					<td><el-input v-model="dataList.tablename" type="text" size="mini" ></el-input></td>
                    <td>{{$t('getapi[8191]')}}</td>
					<td><el-input v-model="dataList.chtablename" type="text" size="mini" ></el-input></td>
                </tr>
				<tr>
                    <td>{{$t('getapi[2285]')}}</td>
					<td>
                        <el-select v-model="dataList.ordertype">
                            <el-option :label="$t('getapi[4349]')" value="ordinary"></el-option>
                            <el-option :label="$t('getapi[2096]')" value="redmark"></el-option>
                        </el-select>
                    </td>
                    <td>{{$t('getapi[2494]')}}</td>
                    <td>
                        <routejump :urlNo="49" :isDialog="1" @callback="beforeRoutJump">
                        <el-input
                                v-model="dataList.chcargoname"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectCargo()"></i>
                        </el-input>
                        </routejump>
                    </td>
					
				</tr>
                <tr>
                    <td>{{$t('getapi[143]')}}</td>
                    <td><el-input v-model="dataList.remark" type="text" size="mini" ></el-input></td>
                </tr>
			</table>
			</div>
			<el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button  size="small" @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button  size="small" type="primary" @click="save"  :loading="loading" :disabled="!btn.edit">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <selector :isVisible="false" :isBatch=true :isSplitPage=true
                  :postUrl="'/Basic/General/GetCargoPositionTypePopupList'" @callback="getCargo"
                  ref="cargo"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
        name: 'purgroup',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                isVisible: false,
                DbTbNames: '', //表名
                userData: [],
                user: "",
                dataSet: [],
                dataList: {},
                oldDataList:[],
                PageIndex: 1,
                PageSize: 50,
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                selectIDData: [],
                ids: "",
                exclusively_id: '',
                btn: {
                    del: false,
                    edit: false
                },
                cargoname:"",
                scrollTop:0,
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8189]"),this.$t("getapi[11]"));
            },
            //按钮操作权限
            authority() {
                let that = this
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('create,refresh,export');
                that.btn.edit = false
                that.btn.del = false
                if(that.userData.Login_Code == 'boss'){
                    that.btn.edit = true
                    that.btn.del = true
                }
            },
            //编辑
            editInfo(row) {
                let that = this;
                that.isVisible = true
                that.dataList = {
                    exclusively_id: row.exclusively_id,
                    tablename: row.tablename,
                    chtablename: row.chtablename,
                    ordertype: row.ordertype,
                    cargoname: row.cargoname,
                    chcargoname: row.chcargoname,
                    remark: row.remark
                }
                that.oldDataList = JSON.stringify(that.dataList)
            },
            // 获取数据
            getView() {
                let that = this;
                that.loading = true;
                let parm = '';
                that.$http.urlpost('/Basic/General/GetCargoTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            save() {
                let that = this;
                that.loading = true;
                let datetime = Common.methods.getDatetime()
                let parm = that.dataList;
                that.$http.urlpost('/Basic/General/SaveCargoType', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isVisible = false;
                        that.getView();
                    }
                    that.loading = false;
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].exclusively_id + ',';
                }
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    Id: that.ids,
                };
                that.$http.urlpost('/Basic/General/DelCargoTypeByID', parm, function (res) {
                    if(res.Success == 1){
                        that.getView();
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 删除
            del(row) {
                this.ids = row.row.exclusively_id;
                this.delf();
            },
            //批量删除
            batchDel() {
                let that = this;
                if(that.selectIDData.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                that.ids = this.selectIDData.substring(0,this.selectIDData.length - 1);
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            // 新增
            add() {
                let that = this
                that.isVisible = true;
                that.dataList = {
                    exclusively_id: '',
                    tablename: '',
                    chtablename: '',
                    ordertype: '',
                    cargoname: '',
                    chcargoname: '',
                    remark: ''
                }
            },
            // 刷新
            reflash() {
                this.getView();
            },
            selectCargo() {
                let that = this;
                that.cargoname=that.dataList.cargoname;
                that.$refs.cargo.clearInput(true);
            },
            getCargo(data) {
                let that = this
                console.log(data)
                let arr1 = ''
                let arr2 = ''
                if(data.length > 0){
                    for(let i=0;i<data.length;i++){
                        arr1 = arr1 + data[i].exclusively_id + ','
                        arr2 = arr2 + data[i].type_name + ','
                    }
                    that.dataList.cargoname = arr1.substring(0, arr1.length - 1)
                    that.dataList.chcargoname = arr2.substring(0, arr2.length - 1)
                }
            },
            //导出·
            exp() {
                let that = this;
                that.loading = true;
                let parm = {
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[8189]')
                }
                that.$http.urlpost('/Basic/General/CargoTypeToExcel', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldDataList != JSON.stringify(that.dataList)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isVisible = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isVisible = false
                    callback(true)
                }
            },
        }
    };
</script>

<style lang="scss" scoped>

table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
